export const emailModalContentType = Object.freeze({
    SEND_EMAIL: "SEND_EMAIL",
    EMAIL_SUCCESS: "EMAIL_SUCCESS",
});
